import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showModal: false,
};

const assignmentSlice = createSlice({
  name: "assignment",
  initialState,
  reducers: {
    toggleModal: (state, action) => {
      state.showModal = action.payload;
    },
  },
});

export const { toggleModal } = assignmentSlice.actions;
export default assignmentSlice.reducer;
